var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 12,
    viewBox: "0 0 24 12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dropdown_svg__path-1",
    d: "m0 0 12 12L24 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown_svg__icons-badges-variations",
    transform: "translate(-456 -320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown_svg__icons/dropdown",
    transform: "translate(456 320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown_svg__android-arrow-dropdown"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dropdown_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dropdown_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dropdown_svg__path-1",
    id: "dropdown_svg__Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dropdown_svg__color/black-tint/0-000000",
    fill: "#000",
    mask: "url(#dropdown_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dropdown_svg__gray-70-4A4A4A",
    d: "M0 0h24v12H0z"
  }))))))));
};
export default SvgDropdown;